import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactMapGL, { NavigationControl } from 'react-map-gl';
import styled from 'styled-components';
import { staticMapProps } from '../config';
import { setMapViewport } from '../store/actions';
import TreeMarkers from './TreeMarkers';

const NavigationControlWrap = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  padding: 15px;
`;

const TreeMap = (props) => {

  const dispatch = useDispatch();
  const mapViewport = useSelector(state => state.mapViewport);

  const mapProps = {
    ...mapViewport,
    ...staticMapProps,
    onViewportChange: (viewport) => dispatch(setMapViewport(viewport)),
  };

  const { trees, selectedTree, treesVisible, onClickTree } = props;

  return (
    <ReactMapGL {...mapProps}>
      {treesVisible ? (
        <TreeMarkers trees={trees} selectedTree={selectedTree} onClickTree={onClickTree} />
      ) : null}
      <NavigationControlWrap>
        <NavigationControl />
      </NavigationControlWrap>
    </ReactMapGL>
  );
};

export default TreeMap;
